import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";
import { dateForDatabase, dateToString } from "../../../../utils/dateAndTime";
import { RecallProductFormValues } from "./RecallProductForm";

export const recallProductsTableHeader: TableHeaderCategoryConfig[] = [
  { value: "productCode", label: "Cod produs", minW: 150 },
  { value: "lot", label: "Lot", minW: 150 },
  { value: "bbd", label: "Data expirare (BBD)", minW: 150 },
];

export const getRecallProductsTableData = (
  lines: RecallProductFormValues[],
): TableData[] =>
  lines.map((line, index) => ({
    id: index,
    crudData: line,
    data: [
      { title: line.productCode },
      { title: line.lot },
      { title: dateToString(dateForDatabase(line.bbd)) },
    ],
  }));
